export default {
    apiKey: "AIzaSyAPMOHpm7sILhICkyZxy_3rrkxLJv7s5cc",
    authDomain: "dbc-asia.firebaseapp.com",
    databaseURL: "https://dbc-asia.firebaseio.com",
    projectId: "dbc-asia",
    storageBucket: "dbc-asia.appspot.com",
    messagingSenderId: "688320120289"
}